import type {HTMLAttributes, ReactNode} from 'react';

import {cn} from '../../helpers/cn';

export type CardSize = 'default' | 'small';

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  title?: ReactNode;
  extra?: ReactNode;
  size?: CardSize;
  bordered?: boolean;
  children?: ReactNode;
};

export function Card({
  title,
  extra,
  size = 'default',
  bordered = true,
  children,
  className,
  ...props
}: CardProps) {
  return (
    <div
      {...props}
      className={cn(
        'flex h-auto flex-col rounded-[8px] bg-white font-iransans',
        bordered && 'border border-gray-19',
        className
      )}
    >
      {(title != null || extra != null) && (
        <div
          className={cn(
            'flex items-center justify-between gap-3 border-b border-gray-19',
            size === 'small' ? 'px-3 py-2' : 'px-6 py-4'
          )}
        >
          {title != null && (
            <div
              className={cn(
                'font-semibold text-neutral-fg',
                size === 'small' ? 'text-[14px]' : 'text-[16px]'
              )}
            >
              {title}
            </div>
          )}
          {extra != null && <div className="shrink-0 text-[14px] text-neutral-fg">{extra}</div>}
        </div>
      )}
      <div className={cn('text-[14px] text-neutral-fg', size === 'small' ? 'p-3' : 'p-6')}>
        {children}
      </div>
    </div>
  );
}
